<div class="card-wrap card-with-bg" *ngIf="company?.name">
  <div class="card-top">
    <div class="logo-btn-wrap d-flex">
      <figure
        class="img-wrap"
        [routerLink]="['/company/', company.companyUrl, 'overview']">
        <img
          *ngIf="
            company.logo !== null &&
            company.logo !== undefined &&
            company.logo !== ''
          "
          src="{{ company?.logo }}"
          class="img"
        />
        <span *ngIf="company.logo == null" class="vname">{{
          company.name | initials
        }}</span>
      </figure>
      <a class="link-icon" [routerLink]="['/company/', company.companyUrl, 'overview']">
        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M19.7198 8.30587C20.0934 8.69324 20.0934 9.30676 19.7198 9.69414L12.0056 17.6941C11.6222 18.0917 10.9891 18.1032 10.5916 17.7198C10.194 17.3365 10.1825 16.7034 10.5659 16.3059L16.6465 10L1 10C0.447715 10 -4.17544e-07 9.55229 -3.93403e-07 9C-3.69261e-07 8.44771 0.447715 8 1 8L16.6465 8L10.5659 1.69414C10.1825 1.29658 10.194 0.663517 10.5916 0.280156C10.9891 -0.103204 11.6222 -0.0916939 12.0056 0.305865L19.7198 8.30587Z" fill="black"/>
        </svg>
      </a>
    </div>
    <div class="company-name-wrapper">
      <a class="company-name" [routerLink]="['/company/', company.companyUrl, 'overview']">{{ company.name }}</a>

      <div class="wrap-notify" (click)="followCompany()">
        <span class="not-active" *ngIf="!company?.user_follow?.includes(userId)">
          <img src="assets/images/icons/bell-icon.svg" class="image"/>
        </span>
        <span class="active-icon" *ngIf="company?.user_follow?.includes(userId)">
          <img src="assets/images/icons/bell-fill-icon.svg" class="image"/>
        </span>
      </div>
    </div>
    <div class="company-location">{{
      company?.headquaters_location | location
    }}</div>

  </div>
  <div class="summary"  [routerLink]="['/company/', company.companyUrl, 'overview']">
    <span
      [innerHTML]="company.about
          ? company?.about?.substring(0, 180) + '....'
          : ''"
    ></span>
  </div>
  <div class="tag-list d-flex"  [routerLink]="['/company/', company.companyUrl, 'overview']">
    <span
      class="tag-name"
      *ngFor="let industry of company?.industry; let i = index"
    >
      {{ industry | industry
      }}{{ company?.industry.length - 1 == i ? "" : ", " }}
    </span>
  </div>
  <!-- <div class="card-bottom d-flex justify-content-between">
    <button
      class="btn btn-dark-blue-bg"
      [routerLink]="['/company/', company.companyUrl, 'overview']">
      View Details
      <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3039 6.51406C14.5654 6.78522 14.5654 7.21468 14.3039 7.48585L8.90389 13.0858C8.63554 13.3641 8.1924 13.3722 7.9141 13.1038C7.63581 12.8355 7.62776 12.3923 7.89611 12.1141L12.1526 7.69995L1.2 7.69995C0.813402 7.69995 0.500002 7.38655 0.500002 6.99995C0.500002 6.61335 0.813402 6.29995 1.2 6.29995L12.1526 6.29995L7.89611 1.88585C7.62776 1.60756 7.63581 1.16441 7.91411 0.896061C8.1924 0.627708 8.63554 0.635765 8.90389 0.914057L14.3039 6.51406Z" fill="white"/>
      </svg>
    </button> -->
    <!-- [queryParams]="{tab: 'overview'}" -->
    <!-- <button *ngIf="isPremium || isAdvance" (click)="compareCompany()" [ngClass]="{'added-in-compare-list btn-black-bg': isAddedInCompareList}"
      class="btn btn-outline-light btn-grey-bg">{{ isAddedInCompareList? "Added":"Compare"}}</button> -->
    <!-- <button class="btn btn-grey2-bg">Compare</button>
  </div> -->
</div>
<div *ngIf="showPopUp">
  <div class="compare-popup-background" (click)="showPopUp = false"></div>
  <div class="compare-popup">
    <figure class="img-wrap">
      <img src="assets/images/Pop-up2.svg" class="img" />
    </figure>
    <button [routerLink]="'/prices'" class="btn btn-blue-bg btn-outline-light">
      Get access to Pro
    </button>
  </div>
</div>
